
import { defineComponent, onMounted, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// realisations
import { dispatcher } from '@/core/realisations/dispatcher.realisation'
import { DataState } from '@/core/classes/DataState.class'
import { PeriodT } from '@/core/types/companies.types'
import { orders } from '@/core/realisations/orders.realisation'

export default defineComponent({
    components: {
        Modal,
        TheInput,
        TheSelect,
    },
    props: {
        orderId: {
            type: Number,
            required: true,
        },
    },
    emits: ['cancel', 'changed'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            new_date: null as string | null,
            periodId: null as number | null,
            for_all_invoices: 0,
        })

        const data_state = reactive({
            periods: new DataState<PeriodT>({}),
        })

        const state_form$ = useVuelidate({ new_date: { required } }, state)

        const changeDate = async () => {
            if (state.is_loading || !props.orderId || !state.new_date) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const payload = {
                    order_id: props.orderId,
                    new_date: state.new_date,
                    for_all_invoices: state.for_all_invoices,
                    periodId: state.periodId,
                }
                await dispatcher.changeOrderTakeDate(payload)

                emit('changed')
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const loadPeriods = async () => {
            data_state.periods.pagination.current_page = 1

            try {
                data_state.periods.is_loading = true
                const response = await orders.getPeriods()
                data_state.periods.list = response.data

                data_state.periods.pagination.total_pages = 1

                data_state.periods.is_failed = false
                data_state.periods.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.periods.failure.catchError(error)

                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_failed = true
                }
            } finally {
                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_loading = false
                }
            }
        }

        onMounted(loadPeriods)

        return { state, data_state, state_form$, changeDate, emitCancel, loadPeriods }
    },
})
